import { render, staticRenderFns } from "./SendMailTemplateEdit.vue?vue&type=template&id=4c9079a6&scoped=true&"
import script from "./SendMailTemplateEdit.vue?vue&type=script&lang=js&"
export * from "./SendMailTemplateEdit.vue?vue&type=script&lang=js&"
import style0 from "./SendMailTemplateEdit.vue?vue&type=style&index=0&id=4c9079a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9079a6",
  null
  
)

export default component.exports